import React, { useEffect, useState } from 'react';
import { Container, Col, Row, Card, CardHeader, CardBody, ListGroup, ListGroupItem, Collapse } from 'reactstrap'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import api from '../../services/api';
import { toast } from 'react-toastify'
import { AuthContext } from '../../contexts/AuthContext'
import studentType from '../../helpers/enums/studentType'

const StyledContainer = styled(Container)`
  padding: 10px;
  overflow-x: hidden;
  color: #004C70;
`
const CourseCard = styled(Card)`
  background-color: unset;
  margin-bottom: 2px;
`;

const StyledHeaderLink = styled(NavLink)`
  color: #444;
  text-decoration: none;
  font-weight: bold;
  &:hover {
    text-decoration: none;
    color: #111;
  }
`

const StyledCardLink = styled(NavLink)`
  color: #444;
  text-decoration: none;
  font-weight: bold;
  text-align: center;
  &:hover {
    text-decoration: none;
    color: #111;
  }
`


function Course(props) {
  const { auth, dispatch } = React.useContext(AuthContext)
  const [collapses, setCollapses] = useState([])
  const [lectures, setLectures] = useState([])

  useEffect(() => {
    const courseId = props.match.params.id;
    api.get(`/course/${courseId}`).then(async res => {
      const { student } = await api.post('/student/get-course', { user: auth.user._id, course: courseId })
      if (student) {
        if (student.status === studentType.INACTIVE_ADMIN || student.status === studentType.INACTIVE_PAYMENT) {
          toast.error("Sua assinatura é inválida, favor verificar seu perfil ou entrar em contato conosco")
          props.history.push('/')
        }
      }
      const resLectures = res.course.lectures;
      setLectures(resLectures)
      let newCollapses = []
      resLectures.forEach(lecture => {
        newCollapses.push(false)
      })
      setCollapses(newCollapses)
    })
  }, [props.match])
  const openCollapse = (index) => {
    let newCollapses = collapses.map((x) => x);
    newCollapses[index] = !collapses[index]
    setCollapses(newCollapses)
  }
  return (
    <StyledContainer>
      <Row>
        <Col xs={12}>
          {lectures.map((lecture, index) => {
            if (lecture.visibility)
              return <CourseCard key={`lecture_${lecture._id}`}>
                <CardHeader onClick={() => openCollapse(index)}>
                  <StyledHeaderLink strict to={`${props.location.pathname}/class/${lecture._id}`}>{lecture.title}</StyledHeaderLink>
                </CardHeader>
                <Collapse isOpen={collapses[index]}>
                  <CardBody>
                    <strong>{lecture.description}</strong>
                    {lecture.contents && <ListGroup style={{ marginTop: 50 }}>
                      <ListGroupItem color="info">
                        {lecture.contents.length === 0 ? 'Sem conteúdos disponíveis nesta aula' : lecture.contents.length > 1 ? '1 ou + conteúdos disponiveis nesta aula' : '1 conteúdo disponivel nesta aula'}
                      </ListGroupItem>
                    </ListGroup>}
                    <div style={{ display: "flex", justifyContent: 'center', marginTop: 10 }}>
                      <StyledCardLink strict to={`${props.location.pathname}/class/${lecture._id}`}>Acessar aula</StyledCardLink>
                    </div>
                  </CardBody>
                </Collapse>
              </CourseCard>
          })}
        </Col>
      </Row>
    </StyledContainer >
  );
}

export default Course;